import React from "react";
import { Navigate } from "react-router-dom";
import { useUserAuth } from "../context/userContext";
const ProtectedRoute = ({ children }) => {
  const { user } = useUserAuth();

  console.log("Check user in Private from auth: ", user);
  if (!user) {
    return <Navigate to="/login" />;
  }
  return children;
};

export default ProtectedRoute;